import { render } from "./PartnersProgram.vue?vue&type=template&id=d2956212&scoped=true"
import script from "./PartnersProgram.vue?vue&type=script&lang=js"
export * from "./PartnersProgram.vue?vue&type=script&lang=js"

import "./PartnersProgram.vue?vue&type=style&index=0&id=d2956212&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2956212"]])

export default __exports__